import { TreeNavigatorLogic } from '../../../../tree/navigation/TreeNavigatorLogic.ts';
import { type ITranslationKey } from '../../../translations/ITranslationKey.ts';
import { type IRootWidget, isRoot } from '../containers/root/IRootWidget.ts';
import { WidgetRepository } from '../WidgetRepository.ts';

/**
 * Applica le traduzioni ad un albero di widget, facendo side-effect
 * sull'oggetto.
 */
export function applyTreeTranslationKeys(
  root: IRootWidget | null | undefined,
  translationKeys: ITranslationKey[],
) {
  if (!root) return;
  const translations = new Map(translationKeys.map(k => [k.chiave, k.valore]));

  TreeNavigatorLogic.forEachNode(root, node => {
    if (isRoot(node)) return;
    const widgetType = WidgetRepository.find(node.type);
    if (!widgetType?.translationSchema) {
      // biome-ignore format: <tbd>
      console.warn(`[applyTreeTranslationKeys] Widget type ${node.type} translation schema not found.`);
      return;
    }

    widgetType.translationSchema.translate(node, translations);
  });
}
